import { createAsyncThunk } from '@reduxjs/toolkit';
import { updatePasswordExternalUser } from '../../api/external-users';

export const updatePasswordExternalUserAsync = createAsyncThunk(
  'externalUsers/updatePassword',
  updatePasswordExternalUser
);
